<div class="fixed inset-0 bg-black/50 flex items-center justify-center z-50" (click)="close.emit()">
  <div class="bg-white rounded-xl shadow-lg p-6 max-w-md w-full relative" (click)="$event.stopPropagation()">
    <h2 class="text-lg font-semibold mb-2">Cargar Cotización</h2>
    <p class="text-sm text-gray-500 mb-4">
      Carga los documentos solicitados arrastrándolos o seleccionándolos.
    </p>

    <div class="border-2 border-dashed border-blue-400 rounded-lg p-6 text-center flex flex-col items-center">
      <span class="material-symbols-outlined text-5xl text-blue-400 mb-2">
        cloud_upload
      </span>
      <p class="text-gray-600 mb-1">
        Arrastra tu archivo aquí o elígelo con un clic.
      </p>
      <p class="text-xs text-gray-400 mb-4">
        Todos los archivos deben ser PDF, claros y legibles.
      </p>
      <input type="file" accept="application/pdf" (change)="onFileSelected($event)" class="hidden" #fileInput/>
      <button class="px-4 py-2 bg-blue-900 text-white rounded-lg hover:bg-blue-800 transition cursor-pointer" (click)="fileInput.click()">
        Seleccionar archivo
      </button>
      <p *ngIf="pdfName" class="mt-3 text-sm text-gray-700">
        Archivo seleccionado: <strong>{{pdfName}}</strong>
      </p>
    </div>
    <div class="flex justify-end mt-6 gap-3">
      <button class="px-4 py-2 cancel-modal-button" (click)="close.emit()">
        Cancelar
      </button> 
      <button class="px-4 py-2 upload-modal-button isabled:opacity-50" [disabled]="!pdfFile" (click)="uploadFile()">
        Subir archivo
      </button>
    </div>
  </div>
</div>